import {RouteSelectorProps, routesSelector, useGetAllRoutesQuery} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {BaseRouteSelect, BaseRouteSelectProps} from "./BaseRouteSelect";

export type RouteSelectProps = Omit<BaseRouteSelectProps, "entities" | "loading"> & {
  selector?: RouteSelectorProps
}

export const RouteSelect = (props: RouteSelectProps) => {
  const {selector, ...rest} = props;

  const selectRoutes = useMemo(() => {
    return routesSelector();
  }, []);

  const {routes, isLoading} = useGetAllRoutesQuery(selector?.regionId, {
    selectFromResult: (result) => ({
      routes: selectRoutes(result, selector),
      isLoading: result.isLoading
    })
  });

  return <BaseRouteSelect entities={routes} loading={isLoading} {...rest} />;
};
